import type { TFunction } from 'i18next'
import type { RecoverableConfiguration, TruckConfiguration } from '#app/store/slices/configurationSlice'
import {
  getConfigurationTitle,
  getMarketDenomination,
  isEmptyOrDefaultConfigurationTitle,
  isEmptyOrDefaultMarketDenomination,
} from '#features/Configuration/ConfigurationTitle'
import { isTruckConfiguration } from './configurationStatus'

export function makeCopyOfConfigurationTitle(configuration: TruckConfiguration, t: TFunction) {
  let configurationTitle = getConfigurationTitle(configuration.title, configuration.marketDenomination, t)

  if (isEmptyOrDefaultConfigurationTitle(configurationTitle, t) && !isEmptyOrDefaultMarketDenomination(configuration.marketDenomination, t)) {
    configurationTitle = getMarketDenomination(configuration.marketDenomination, t) ?? configurationTitle
  }

  const copyTitle = t('configuration.title.copy-of-prefix', 'Copy of {{title}}', { title: '' })
  const baseConfigurationTitle = configurationTitle.replace(copyTitle, '')
  return t('configuration.title.copy-of-prefix', 'Copy of {{title}}', { title: baseConfigurationTitle })
}

export function extractConfigurationTitle(configuration: TruckConfiguration | RecoverableConfiguration | undefined, t: TFunction) {
  if (isTruckConfiguration(configuration)) {
    return getConfigurationTitle(configuration.title, configuration.marketDenomination, t)
  }
  return getConfigurationTitle(undefined, undefined, t)
}
